(function () {
  /* ---------- CONSTANTS ---------- */
  const LS_SAMPLES = "sample_products"; // stores current sample list
  const MAX_SAMPLES = 5;
  const CHECKOUT_KEY = "in_sample_checkout"; // flag to detect return from checkout

  /* ---------- LOCAL STORAGE HELPERS ---------- */
  const getSamples = () => JSON.parse(localStorage.getItem(LS_SAMPLES) || "[]");
  const saveSamples = (arr) =>
    localStorage.setItem(LS_SAMPLES, JSON.stringify(arr));

  /* ---------- UTILITY ---------- */
  const normalizeURL = (src) =>
    !src
      ? ""
      : src.startsWith("http")
      ? src
      : src.startsWith("//")
      ? "https:" + src
      : src;

  /* ---------- CART COUNT BUBBLE ---------- */
  const updateCartCountBubble = () => {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        const bubble = document.querySelector(".cart-count-bubble");
        if (!bubble) return;
        const total = cart.items.reduce((sum, i) => sum + i.quantity, 0);
        bubble.innerHTML = `
          <span aria-hidden="true">${total}</span>
          <span class="visually-hidden">${total} ${
          total === 1 ? "item" : "items"
        }</span>`;
      })
      .catch(console.error);
  };

  /* ---------- MODAL OPEN/CLOSE ---------- */
  const openModal = () => {
    const m = document.getElementById("sample-modal");
    if (m) {
      m.style.display = "flex";
      requestAnimationFrame(() => m.classList.add("active"));
    }
  };
  const closeModal = () => {
    const m = document.getElementById("sample-modal");
    if (m) {
      m.classList.remove("active");
      setTimeout(() => (m.style.display = "none"), 350);
    }
  };
  window.closeSampleModal = closeModal;

  /* ---------- RENDER SAMPLE LIST ---------- */
  const renderSampleList = () => {
    const list = document.getElementById("sample-list");
    const go = document.querySelector(".sample-checkout-btn");
    if (!list || !go) return;

    const samples = getSamples();
    list.innerHTML = "";
    if (!samples.length) {
      go.href = "#";
      go.classList.add("disabled");
      return;
    }
    go.classList.remove("disabled");

    samples.forEach((s) =>
      list.insertAdjacentHTML(
        "beforeend",
        `
        <div class="sample-card">
          <button class="sample-card-remove" data-v="${s.variantId}" aria-label="Remove ${s.title}">×</button>
          <img loading="lazy" src="${s.image}" alt="${s.title}">
          <div class="sample-card-title">${s.title}</div>
        </div>`
      )
    );

    go.href = `/cart/${samples.map((s) => `${s.variantId}:1`).join(",")}`;
  };

  /* ---------- “GET SAMPLE” BUTTON CLICK ---------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".btn--get-sample");
    if (!btn) return;

    e.preventDefault();

    const variantId = btn.dataset.sampleVariant?.trim();
    if (!variantId) {
      console.warn(" No sample variant on button – click ignored", btn);
      return;
    }

    let fullProd = Number(
      (btn.dataset.originalProduct || "").split("/Product/").pop() || 0
    );

    /* -- Remove any full‑size product in cart -- */
    if (fullProd) {
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) =>
          Promise.all(
            cart.items
              .filter((i) => i.product_id === fullProd)
              .map((i) =>
                fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: i.key, quantity: 0 }),
                })
              )
          ).then(updateCartCountBubble)
        );
    }

    /* -- Manage samples list -- */
    let samples = getSamples();
    if (samples.some((s) => s.variantId === variantId)) {
      openModal();
      renderSampleList();
      return;
    }
    if (samples.length >= MAX_SAMPLES) {
      alert(`Max ${MAX_SAMPLES} samples.`);
      openModal();
      renderSampleList();
      return;
    }

    samples.push({
      variantId,
      title: btn.dataset.productTitle,
      image: normalizeURL(btn.dataset.sampleImageUrl),
    });
    saveSamples(samples);
    openModal();
    renderSampleList();
  });

  /* ---------- REMOVE/CLEAR IN MODAL ---------- */
  document.addEventListener("click", (e) => {
    const rm = e.target.closest(".sample-card-remove");
    if (rm) {
      saveSamples(getSamples().filter((s) => s.variantId !== rm.dataset.v));
      renderSampleList();
      return;
    }
    if (e.target.closest(".sample-clear")) {
      localStorage.removeItem(LS_SAMPLES);
      renderSampleList();
    }
  });

  /* ---------- CHECKOUT WITH SAMPLES ---------- */
  document.addEventListener("click", async (e) => {
    const go = e.target.closest(".sample-checkout-btn");
    if (!go) return;

    e.preventDefault();
    if (go.dataset.locked) return;
    go.dataset.locked = "true";
    go.classList.add("loading");

    const samples = getSamples();
    if (!samples.length) {
      alert("No samples selected.");
      go.dataset.locked = "";
      go.classList.remove("loading");
      return;
    }

    localStorage.setItem(CHECKOUT_KEY, "true");
    await fetch("/cart/clear.js", { method: "POST" });

    const ids = samples.map((s) => `${s.variantId}:1`).join(",");
    window.location.href = `/cart/${ids}?checkout`;
  });

  /* ---------- BACK‑BUTTON HANDLING ---------- */
  window.addEventListener("pageshow", (ev) => {
    const cameBack = ev.persisted || window.performance?.navigation?.type === 2;
    if (!cameBack) return;

    const fromCheckout = localStorage.getItem(CHECKOUT_KEY) === "true";
    if (fromCheckout) {
      console.log("↩️ Returned from sample checkout – clearing cart again");
      localStorage.removeItem(CHECKOUT_KEY);
      fetch("/cart/clear.js", { method: "POST" }).finally(() =>
        setTimeout(updateCartCountBubble, 300)
      );
    } else {
      setTimeout(updateCartCountBubble, 100);
    }
  });

  /* ---------- INITIAL BUBBLE REFRESH ---------- */
  document.addEventListener("DOMContentLoaded", updateCartCountBubble);
})();
